/**
 * Kanonischer, URL-sicherer Slug (urlKey) — spiegelt die Backend-Logik
 * (`backend/src/utils/slug.util.ts`): lowercase, deutsche Umlaute/ß
 * ausgeschrieben, übrige Diakritika entfernt, Alphabet [a-z0-9_-], Rest → `-`.
 *
 * Genutzt vom öffentlichen Viewer, um alte/gemischt geschriebene Links
 * (z. B. `/Saskia_schwarzenberger`) auf die kanonische Form
 * (`/saskia_schwarzenberger`) umzuleiten.
 */
export function slugify(raw: string | undefined | null): string {
  if (!raw) return ''
  const umlauts: Record<string, string> = { ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' }
  return raw
    .toLowerCase()
    .trim()
    .replace(/[äöüß]/g, (m) => umlauts[m] ?? m)
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/_{2,}/g, '_')
    .replace(/^[-_]+|[-_]+$/g, '')
}
